import ComboVehicleInfoDetailModal from './combo-vehicle-info-detail-modal.vue'
export default ComboVehicleInfoDetailModal
